import {
  Document, Packer, Paragraph, TextRun, AlignmentType,
  Table, TableRow, TableCell, WidthType, VerticalAlign, BorderStyle, HeightRule,
} from 'docx';

const BODY_FONT = { ascii: 'MS Mincho', eastAsia: 'MS Mincho', hAnsi: 'MS Mincho' };

const THIN = { style: BorderStyle.SINGLE, size: 4, color: '000000' };
const TABLE_BORDERS = { top: THIN, bottom: THIN, left: THIN, right: THIN, insideHorizontal: THIN, insideVertical: THIN };

// 実物の「出張報告書」様式（別紙第２号様式）に合わせた寸法（DXA）。
const STAMP_WIDTHS = [1600, 1600, 1600];
const RESULT_WIDTHS = [1134, 8766]; // ラベル＋値、合計9900＝ページの印刷可能幅と一致

function stampTable() {
  return new Table({
    width: { size: STAMP_WIDTHS.reduce((a, b) => a + b, 0), type: WidthType.DXA },
    columnWidths: STAMP_WIDTHS,
    alignment: AlignmentType.RIGHT,
    borders: TABLE_BORDERS,
    rows: [
      new TableRow({
        children: STAMP_WIDTHS.map((w, i) => new TableCell({
          width: { size: w, type: WidthType.DXA },
          verticalAlign: VerticalAlign.CENTER,
          children: [new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [new TextRun(['理事長', '業務執行理事', '施設長'][i])],
          })],
        })),
      }),
      new TableRow({
        height: { value: 900, rule: HeightRule.AT_LEAST },
        children: STAMP_WIDTHS.map((w) => new TableCell({
          width: { size: w, type: WidthType.DXA },
          children: [new Paragraph({ text: '' })],
        })),
      }),
    ],
  });
}

function resultRow(label, lines, height) {
  const arr = (Array.isArray(lines) ? lines : [lines]).filter((l) => l);
  return new TableRow({
    height: { value: height, rule: HeightRule.AT_LEAST },
    children: [
      new TableCell({
        width: { size: RESULT_WIDTHS[0], type: WidthType.DXA },
        verticalAlign: VerticalAlign.CENTER,
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun(label)] })],
      }),
      new TableCell({
        width: { size: RESULT_WIDTHS[1], type: WidthType.DXA },
        margins: { top: 100, bottom: 100, left: 120, right: 120 },
        children: arr.length ? arr.map((l) => new Paragraph({ children: [new TextRun(l)] }))
          : [new Paragraph({ children: [new TextRun('')] })],
      }),
    ],
  });
}

/**
 * 出張報告書（別紙第２号様式）をWordファイル(Blob)にする。
 * fields: { submitDate, orderDate, role, name, other }, resultText: 成果（本文）
 */
export async function buildShutchoWordBlob(fields, resultText) {
  const resultLines = (resultText || '').split('\n');
  const otherLines = (fields.other || '').split('\n');

  const doc = new Document({
    styles: {
      default: {
        document: { run: { font: BODY_FONT, size: 21 } }, // 10.5pt（原本のsz=None相当。本文は既存の他様式に合わせ10.5ptとした）
      },
    },
    sections: [{
      properties: {
        page: {
          size: { width: 11906, height: 16838 }, // A4
          margin: { top: 1260, right: 926, bottom: 1080, left: 1080, header: 851, footer: 992, gutter: 0 },
        },
      },
      children: [
        new Paragraph({ children: [new TextRun('別紙第２号様式')] }),
        new Paragraph({
          alignment: AlignmentType.RIGHT,
          spacing: { after: 0 },
          children: [new TextRun(fields.submitDate || '　　　年　　月　　日')],
        }),
        stampTable(),
        new Paragraph({ text: '' }),
        new Paragraph({ text: '' }),
        new Paragraph({ text: '' }),
        new Paragraph({
          alignment: AlignmentType.CENTER,
          children: [new TextRun({ text: '出張報告書', size: 40 })],
        }),
        new Paragraph({ text: '' }),
        new Paragraph({ children: [new TextRun(`出張者　役職　${fields.role || ''}`)] }),
        new Paragraph({ children: [new TextRun(`氏名　${fields.name || ''}　　　　印`)] }),
        new Paragraph({ text: '' }),
        new Paragraph({
          children: [new TextRun(`${fields.orderDate || '　　　年　　月　　日'}付の出張命令書により、行った出張について以下のように報告します。`)],
        }),
        new Paragraph({ text: '' }),
        new Table({
          width: { size: RESULT_WIDTHS.reduce((a, b) => a + b, 0), type: WidthType.DXA },
          columnWidths: RESULT_WIDTHS,
          borders: TABLE_BORDERS,
          rows: [
            resultRow('成　　果', resultLines, 7000),
            resultRow('その他', otherLines, 900),
          ],
        }),
      ],
    }],
  });
  return Packer.toBlob(doc);
}
